import React from 'react';
import styled from 'styled-components/macro';
import { ButtonInvertedLink } from '../../../UI/Button/Button';
import TasklyPreviewImg from '../../../../assets/images/KaenguruMockUp_Preview.png';

const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  /* background: #2B7189; */
  background: #28677d;
  height: 360px;
  width: 100%;
`;

const TextMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  margin: 16px 0 8px;
  color: #fff;
  font-family: miller-display, serif;
  font-weight: 600;
  font-style: normal;
  font-size: 32px;
  width: 100%;
`;

const SubTitle = styled.div`
  width: 100%;
  color: #fff;
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-bottom: 16px;
  width: 100%;
`;

const PreviewImgWrapper = styled.div`
  height: 180px;
`;

const BackgroundDesktop = styled(Background)`
  flex-direction: row;
  justify-content: center;
  height: 500px;
`;

const PreviewWrapperDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  width: 700px;
  height: 300px;
`;

const TextAndButtonDesktop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TextDesktop = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleDesktop = styled(Title)`
  margin: 16px 0 12px;
  text-align: left;
`;

const SubTitleDesktop = styled(SubTitle)`
  font-weight: 400;
  text-align: left;
  line-height: 23px;
  width: 310px;
`;

const ButtonWrapperDesktop = styled.div`
  display: flex;
`;

const PreviewImgWrapperDesktop = styled.div`
  height: 270px;
  align-self: center;
`;

const PreviewImg = styled.img`
  border-radius: 3%;
  height: 100%;
  width: auto;
`;

const PreviewMobile = () => (
  <Background>
    <TextMobile>
      <Title>Känguru math app</Title>
      <SubTitle>
        Redesign and redevelopment of the popular math training app
      </SubTitle>
    </TextMobile>
    <PreviewImgWrapper>
      <PreviewImg src={TasklyPreviewImg} alt="KaenguruPreview"></PreviewImg>
    </PreviewImgWrapper>
    <ButtonWrapper>
      <ButtonInvertedLink exact="true" to="/work/kaenguru">
        View Project
      </ButtonInvertedLink>
    </ButtonWrapper>
  </Background>
);

const PreviewDesktop = () => (
  <BackgroundDesktop>
    <PreviewWrapperDesktop>
      <TextAndButtonDesktop>
        <TextDesktop>
          <TitleDesktop>Känguru math app</TitleDesktop>
          <SubTitleDesktop>
            Redesign and redevelopment of the popular math training app
            <br />
            <br />
            Use this app to prepare for the next Känguru competition or just
            have fun solving challenging and varied tasks. You can choose the
            tasks by class level, difficulty of the tasks, year of the tasks and
            type of the tasks.
          </SubTitleDesktop>
        </TextDesktop>
        <ButtonWrapperDesktop>
          <ButtonInvertedLink exact="true" to="/work/kaenguru">
            View Project
          </ButtonInvertedLink>
        </ButtonWrapperDesktop>
      </TextAndButtonDesktop>
      <PreviewImgWrapperDesktop>
        <PreviewImg src={TasklyPreviewImg} alt="KaenguruPreview"></PreviewImg>
      </PreviewImgWrapperDesktop>
    </PreviewWrapperDesktop>
  </BackgroundDesktop>
);

const KaenguruPreview = (props) => {
  // const mq = window.matchMedia('(max-width: 400px)');

  return (
    <>
      {props.desktop ? <PreviewDesktop /> : <PreviewMobile />}
      {/* {isMobile && window.matchMedia('(max-width: 768px)').matches ? (
        <PreviewMobile />
      ) : (
        <PreviewDesktop />
      )} */}
    </>
    // <Background>
    //   {isMobile && document.documentElement.clientWidth < 400 ? (
    //     <PreviewMobile />
    //   ) : (
    //     <PreviewDesktop />
    //   )}
    // </Background>

    // <Background>
    //   {isMobile && mq.matches ? (
    //     <PreviewMobile />
    //   ) : (
    //     <PreviewDesktop />
    //   )}
    // </Background>
  );
};

export default KaenguruPreview;
